/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Cannot_Move_Folder_Into_ItselfInputs */



/**
* | output |
* | --- |
* | "Cannot move a folder into itself" |
*
* @param {Spaces_Cannot_Move_Folder_Into_ItselfInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_cannot_move_folder_into_itself = /** @type {((inputs?: Spaces_Cannot_Move_Folder_Into_ItselfInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Cannot_Move_Folder_Into_ItselfInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Ein Ordner kann nicht in sich selbst verschoben werden")
	return /** @type {LocalizedString} */ ("Cannot move a folder into itself")
});